
import React, {useEffect, useState, useMemo} from 'react';
import _ from "lodash";
import {useDispatch, useSelector} from "react-redux";
import {getSessionLogs} from "../redux/actions/index";
import OBCSpinner from "./util/OBC";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCopy} from "@fortawesome/pro-solid-svg-icons";

const sessionIDSelector = state => state.playlist.data.routeID;
const sessionLogsSelector = state => state.playlist.logData;

const SessionLogs = () => {

    const dispatch = useDispatch()

    const sessionID = useSelector(sessionIDSelector);
    const logData = useSelector(sessionLogsSelector);

    const [loading, setLoading] = useState(true);

    useEffect(() => {

        if(sessionID){
            dispatch(getSessionLogs(sessionID, () => {
                setLoading(false)
            }))
        }
    }, [sessionID, dispatch]);

    const copyClicked = (link) => {
        if(navigator.clipboard) {
            navigator.clipboard.writeText(link);
        }
    }

    const sessionLogRows = useMemo(() => {
        if(!logData || !logData.length) {
            return null;
        }
        return logData.map(log => {
            let splitLogsArray = [];
            let logsObject = {};
            const timeString = new Date(1000 * log.timestamp).toUTCString();
            const logs = log.log.split(';');

            for(let i = 0; i < logs.length; i++){
                const thisLog = logs[i].replace(/\s/g, ""); //Remove whitespaces
                // TODO - consider markdown or similar
                if(thisLog.indexOf("<https://") === 0) {
                    const splitUrl = thisLog.split("|"); //Split out label
                    const tidyLabel = splitUrl[1].replace(">", ":");
                    const tidyUrl = splitUrl[0].replace("<", "");
                    const link = <a target="_blank" rel="noopener noreferrer" href={tidyUrl}>{tidyUrl}</a>;

                    const url = [tidyLabel, link];
                    splitLogsArray.push(url);
                } else {
                    const splitLog = thisLog.split(':');
                    splitLogsArray.push(splitLog);
                }
            }

            for(let x = 0; x < splitLogsArray.length; x++){
                const label = splitLogsArray[x][0];
                const val = splitLogsArray[x][1];
                logsObject[label] = val;
            }

            return <div className='LogRow'>
                <div className="LogRow__Date">
                    <span>{timeString}</span>
                </div>
                {Object.keys(logsObject).map((key) => {
                    return <div className='LogRow__Item'>
                        <p className="label">{key}</p>
                        <p>{logsObject[key]}</p>
                        {(_.isObject(logsObject[key]) && logsObject[key].type === 'a') &&
                        <button className="LogRow__Item__Copy" onClick={() => copyClicked(logsObject[key].props.href)}>
                            <FontAwesomeIcon icon={faCopy}/>
                        </button>
                        }
                    </div>
                })}
            </div>
        })
    }, [logData]);


    const content = useMemo(() => {
        if(loading){
            return (
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%'}}>
                    <OBCSpinner colorScheme={"mono"}/>
                </div>
            )
        }else if(_.get(logData, ["length"], false)){
            return sessionLogRows
        }else{
            return <span className="Text">No Session Logs Found</span>
        }
    }, [loading, logData, sessionLogRows])


    return <div className='LogRowContainer'>
                {content}
            </div>
}

export default SessionLogs